import React from "react";
import {ArrowBackCircle} from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/NoBodyPost";
import WMSAuthenticate from "../Functions/WMSAuthenticate"
import stylesWMS from "./stylesWMS";
import stylesMed from "../MedRep/stylesMed";
import DatePicker from "react-datepicker";
import SearchFilterFunction from "../Functions/SearchFilter"

export default class TransactionList extends React.Component {

    constructor() {
        super();
        this.state = {
            orders: [],
            showDeleteAlert: false,
            requiredFields: {Date: true, location: false, source: false},
            showalert: false,
            alertdanger: "",
            itemIndex: 0,
            bar: "",
            Date: new Date(),
            authenticate: false,
            token: "",
            location: "",
            locations: [],
            task: [],
            loading: true,
            ordersCopy: [],
            noData: true,
            tableHeader: [],
            transactionType: [{"name": "/Requests"}, {"name": "/Transfers"}],
            selectedType: -1,
            source: "",
            destination: "",
            showBar: false,
            disableScan: true,
            module: -1,
            transaction: -1,
            status: [],
            loadingData: false,
            username: ""
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        //Setting the transaction type
        await this.state.transactionType.map((item, index) => {
            if (this.props.history.location.pathname === item.name) {
                this.setState({selectedType: index})
            }
        });

        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });

        const token = JSON.parse(localStorage.getItem("Token"));
        const user = JSON.parse(localStorage.getItem("Username"));
        this.setState({token: token, username: user});

        //Setting the transaction based on selected module
        const title = JSON.parse(localStorage.getItem("Title"));
        if (title[0] === 4) {
            this.setState({transaction: 0}); //WMS
        } else if (title[0] === 5) {
            this.setState({transaction: 1}); //OMS
        }

        if (this.state.transaction === 0) {
            this.compWMS();
        } else if (this.state.transaction === 1) {
            this.compOMS();
        }
    }

    compOMS = async () => {
        this.setState({tableHeader: [{"name": "Name"}, {"name": "Date"}]});
        const getLocations = constantURI() + "GetLocations?token=" + this.state.token + "&user=" + this.state.username;
        const getStatus = constantURI() + "GetStatus?token=" + this.state.token + "&user=" + this.state.username;
        //If online
        if (this.state.authenticate) {
            await _post(getLocations).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await this.setState({locations: data.result});
                        localStorage.setItem('Locations', JSON.stringify(this.state.locations));
                        var temp = [];
                        await this.state.locations.map((item) => {
                            if (item.name) {
                                temp.push(item);
                            }
                        });
                        this.setState({locations: temp});
                    } else {
                        const location = localStorage.getItem('Locations');
                        this.setState({locations: JSON.parse(location)});
                    }
                })
            });
            await _post(getStatus).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await this.setState({status: data.result, loading: false});
                        localStorage.setItem('Status', JSON.stringify(this.state.status));
                    } else {
                        const Status = localStorage.getItem('Status');
                        this.setState({status: JSON.parse(Status), loading: false});
                    }
                })
            });
        }
        //If offline
        else {
            const location = localStorage.getItem('Locations');
            const status = localStorage.getItem('Status');
            if (location === null || location === undefined || status === null || status === undefined) {
                alert("Please connect to the Internet");
                this.props.history.push("/LandingPageWMS");
            } else {
                this.setState({locations: JSON.parse(location), status: JSON.parse(status), loading: false});
            }
        }
        const module = JSON.parse(localStorage.getItem("Interface"));
        // If user is packing 
        if (this.state.selectedType === 0) {
            this.setState({stage: "Packaged"});
        } else {
            //If user is driver (ships to warehouse)
            if (module !== 3)
                this.setState({stage: "Shipped"});
            //If user is driver (ships to client)
            else
                this.setState({stage: "Landed"});
        }
    }

    compWMS = async () => {
        this.setState({tableHeader: [{"name": "Name"}, {"name": "Date"}, {"name": "Source"}, {"name": "Destination"}]});

        const module = JSON.parse(localStorage.getItem("Interface"));
        //If user is packaging 
        if (module === 1) {
            this.setState({stage: "Packaged", module: module});
        }
        //If user is receiving
        else if (module === 2) {
            this.setState({stage: "Shipped", module: module});
        }
        //If user is repackaging
        else if (module === 3) {
            this.setState({stage: "Landed", module: module});
        }

        const getLocations = constantURI() + "GetLocations?token=" + this.state.token + "&user=" + this.state.username + "&type=internal";
        //If online
        if (this.state.authenticate) {
            await _post(getLocations).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({locations: data.result, loading: false});
                        localStorage.setItem('Locations', JSON.stringify(this.state.locations));
                    } else {
                        const location = localStorage.getItem('Locations');
                        this.setState({locations: JSON.parse(location), loading: false});
                    }
                })
            })
        }
        //If offline
        else {
            const location = localStorage.getItem('Locations');
            if (location === null || location === undefined) {
                alert("Please connect to the Internet");
                this.props.history.push("/LandingPageWMS");
            } else {
                this.setState({locations: JSON.parse(location), loading: false});
            }
        }
    }

    onChangeBar = (e) => {
        this.setState({bar: e.target.value.substring(0, 10)});
    }

    onOrderClick = async (item) => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        //If online
        if (this.state.authenticate) {
            localStorage.setItem("Transaction", JSON.stringify(item));
            this.props.history.push(this.state.transactionType[this.state.selectedType].name.substring(0, this.state.transactionType[this.state.selectedType].name.length - 1) + "Detail");
        }
        //If offline
        else {
            alert("Please connect to the internet");
        }
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.orders, this.state.ordersCopy, this.state.noData);
        this.setState({orders: values.items, noData: values.noData})
    }

    onSelectFromDate = async (date) => {
        await this.setState({Date: date});

        if (date === null || date === "")
            this.setState({...this.state.requiredFields.Date = false, showBar: false});
        else
            this.setState({...this.state.requiredFields.Date = true});
        //If WMS
        if (this.state.transaction === 0) {
            if (this.state.requiredFields.Date && this.state.requiredFields.location) {
                this.setState({disableScan: false});
            } else {
                this.setState({disableScan: true});
            }
        }
        //If OMS
        else {
            if (this.state.requiredFields.Date)
                this.setState({disableScan: false});
            else
                this.setState({disableScan: true});
        }
    }

    onChangeLocation = (e) => {
        this.setState({location: e.target.value, destination: e.target.options[e.target.selectedIndex].text});

        if (e.target.value === "")
            this.setState({...this.state.requiredFields.location = false, showBar: false});
        else
            this.setState({...this.state.requiredFields.location = true});
        //If WMS
        if (this.state.transaction === 0) {
            //If transaction is RFQ
            if (this.state.selectedType === 0) {
                if (this.state.requiredFields.Date && this.state.requiredFields.location) {
                    this.setState({disableScan: false});
                } else {
                    this.setState({disableScan: true});
                }
            }
            //If transaction is transfer
            else if (this.state.selectedType === 1) {
                if (this.state.requiredFields.source && this.state.requiredFields.location) {
                    this.setState({disableScan: false});
                } else {
                    this.setState({disableScan: true});
                }
            }
        }
    }

    onChangeSource = (e) => {
        this.setState({source: e.target.value});

        if (e.target.value === "")
            this.setState({...this.state.requiredFields.source = false, showBar: false});
        else
            this.setState({...this.state.requiredFields.source = true});
        //If WMS
        if (this.state.transaction === 0) {
            if (this.state.requiredFields.source && this.state.requiredFields.location) {
                this.setState({disableScan: false});
            } else {
                this.setState({disableScan: true});
            }
        }
    }

    getOrders = async (values) => {
        this.setState({loadingData: true});
        //If transaction is RFQ or if selected module is OMS
        if (this.state.selectedType === 0 || this.state.transaction === 1) {
            if (!values.Date && !values.location) {
                this.setState({alertdanger: "Date & Destination are required"});
                this.setState({showalert: true, loadingData: false});
            } else if (!values.Date && values.location) {
                this.setState({alertdanger: "Date is required"});
                this.setState({showalert: true, loadingData: false});
            } else if (values.Date && !values.location) {
                this.setState({alertdanger: "Destination is required"});
                this.setState({showalert: true, loadingData: false});
            } else {
                this.isDone();
            }
        }
        //If transaction is transfer
        else if (this.state.selectedType === 1) {
            if (!values.source && !values.location) {
                this.setState({alertdanger: "Source & destination location are required"});
                this.setState({showalert: true, loadingData: false});
            } else if (!values.location && values.source) {
                this.setState({alertdanger: "Destination location is required"});
                this.setState({showalert: true, loadingData: false});
            } else if (!values.source && values.location) {
                this.setState({alertdanger: "Source location is required"});
                this.setState({showalert: true, loadingData: false});
            } else {
                this.isDone();
            }
        }
    }

    isDone = async () => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        var readURI = constantURI();
        //If WMS
        if (this.state.transaction === 0) {
            //If online
            if (this.state.authenticate) {
                const tempToDate = new Date(this.state.Date);
                const date = `${tempToDate.getFullYear()}/${tempToDate.getMonth() + 1}/${tempToDate.getDate()}`;
                this.setState({alertdanger: "Work Successful"});
                if (this.state.selectedType === 0) {
                    readURI = readURI + "GetPOs?token=" + this.state.token + "&user=" + this.state.username + "&type=3&location=" + Number(this.state.location) + "&date=" + date;
                } else {
                    readURI = readURI + "GetTransfers?token=" + this.state.token + "&user=" + this.state.username + "&type=5&state=assigned&stage=" + this.state.stage + "&source=" + Number(this.state.source) + "&destination=" + Number(this.state.location);
                }
                await _post(readURI).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.setState({orders: data.result, ordersCopy: data.result, loadingData: false});
                            localStorage.setItem('Transactions', JSON.stringify(this.state.orders));
                        } else {
                            const orders = localStorage.getItem('Transactions');
                            this.setState({orders: JSON.parse(orders), loadingData: false});
                        }
                    })
                })
            }
            //If offline
            else {
                this.setState({alertdanger: "Please connect to the internet!"});
            }
        }
        //If OMS
        else {
            //If online
            if (this.state.authenticate) {
                const tempToDate = new Date(this.state.Date);
                const date = `${tempToDate.getFullYear()}/${tempToDate.getMonth() + 1}/${tempToDate.getDate()}`;
                this.setState({alertdanger: "Work Successful"});

                if (this.state.location === "")
                    readURI = readURI + "GetSOs?token=" + this.state.token + "&user=" + this.state.username + "&stage=" + this.state.stage + "&date=" + date;
                else
                    readURI = readURI + "GetSOs?token=" + this.state.token + "&user=" + this.state.username + "&stage=" + this.state.stage + "&date=" + date + "&location=" + this.state.destination;
                console.log(readURI);
                await _post(readURI).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.setState({orders: data.result, ordersCopy: data.result, loadingData: false});
                            localStorage.setItem('Transactions', JSON.stringify(this.state.orders));
                        } else {
                            const orders = localStorage.getItem('Transactions');
                            this.setState({orders: JSON.parse(orders), loadingData: false});
                        }
                    })
                })
            }
            //If offline
            else {
                this.setState({alertdanger: "Please connect to the internet!"});
            }
        }
    }

    searchItem = async () => {
        var readURI = constantURI();
        const tempToDate = new Date(this.state.Date);
        const date = `${tempToDate.getFullYear()}/${tempToDate.getMonth() + 1}/${tempToDate.getDate()}`;
        if (this.state.transaction === 0)
            readURI = readURI + "GetTransfer?token=" + this.state.token + "&user=" + this.state.username + "&type=5&state=assigned&stage=" + this.state.stage + "&source=" + Number(this.state.source) + "&destination=" + Number(this.state.location) + "&name=" + this.state.bar;
        else
            readURI = readURI + "GetSO?token=" + this.state.token + "&user=" + this.state.username + "&stage=" + this.state.stage + +"&name=" + this.state.bar + "&date=" + date;
        //If online
        if (this.state.authenticate) {
            await _post(readURI).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await this.setState({orders: data.result, ordersCopy: data.result, loading: false});
                        localStorage.setItem('Transactions', JSON.stringify(this.state.orders));
                    } else {
                        const orders = localStorage.getItem('Transactions');
                        this.setState({orders: JSON.parse(orders), loading: false});
                    }
                })
            })
        }
        //If offline
        else {
            const orders = localStorage.getItem('Transactions');
            this.setState({orders: JSON.parse(orders), loading: false});
        }
        //If WMS
        if (this.state.transaction === 0) {
            if (this.state.orders.length === 0) {
                alert("The entered source and destination locations are not compatible to the transfer scanned. ");
            }
        }
        //If OMS
        else {
            if (this.state.orders.length === 0) {
                alert("The entered date is not compatible to the transfer scanned.");
            }
        }
    }

    Header = () => {
        return (
            <div>
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn"
                                         onClick={() => (this.state.transaction === 0) ? this.props.history.push("/LandingPageWMS") : this.props.history.push("/LandingPageOMS")}
                                         color={'#00bfff'} height="50px" width="50px"/>
                    </div>
                    <h3 className="col d-flex align-items-center justify-items-center">{(this.state.selectedType !== -1) ? (this.state.transaction === 0) ? this.state.transactionType[this.state.selectedType].name.substring(1) : "Orders" : null}</h3>
                    <div className="col m-4">
                        <button className="getorder btn btn-sm"
                                onClick={() => this.getOrders(this.state.requiredFields)}>Get Orders
                        </button>
                    </div>
                </div>
                <br/>
            </div>
        )
    }

    subHeader = () => {
        return (
            <div>
                <div className="row">
                    {(this.state.selectedType === 0 || this.state.transaction === 1) ?
                        <div className="col m-4">
                            <h6 style={stylesWMS.reportDate}>Date </h6>
                            <div style={stylesWMS.datelocation}><DatePicker className="form-control"
                                                                            selected={this.state.Date}
                                                                            onChange={(date) => this.onSelectFromDate(date)}
                                                                            style={stylesWMS.datelocation}/></div>
                        </div>
                        :
                        <div className="col m-4">
                            <h6 style={stylesWMS.reportDate}>Source </h6>
                            <select className="form-control" id="sel1" value={this.state.source}
                                    onChange={this.onChangeSource}
                                    name="sellist1" style={stylesWMS.datelocation}>
                                <option value=""></option>
                                {this.state.locations.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>{item.complete_name}</option>
                                    )
                                })
                                }
                            </select>
                        </div>
                    }
                    <div className="col m-4">
                        <h6 style={stylesWMS.reportDate}>Destination </h6>
                        <select className="form-control" id="sel1" value={this.state.location}
                                onChange={this.onChangeLocation}
                                name="sellist1" style={stylesWMS.datelocation}>
                            <option value=""></option>
                            {this.state.locations.map((item, index) => {
                                return (
                                    <option key={index}
                                            value={item.id}>{(item.complete_name !== undefined) ? item.complete_name : item.name}</option>
                                )
                            })
                            }
                        </select>
                    </div>
                    {/*{(this.state.transaction === 1) ?*/}
                    {/*    <div className="col m-4">*/}
                    {/*        <h6 style={stylesWMS.reportDate}>Status </h6>*/}
                    {/*        <select className="form-control" id="sel1" value={this.state.source} onChange={this.onChangeSource}*/}
                    {/*            name="sellist1" style={stylesWMS.datelocation}>*/}
                    {/*            <option value=""></option>*/}
                    {/*            {this.state.status.map((item, index) => {*/}
                    {/*                return (*/}
                    {/*                    <option key={index} value={item.id}>{item.name}</option>*/}
                    {/*                )*/}
                    {/*            })*/}
                    {/*            }*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    {/*    null*/}
                    {/*}*/}
                </div>
                {(this.state.selectedType === 1) ?
                    <div className="m-4" style={stylesWMS.rightDirection}>
                        <button className={(this.state.disableScan) ? "btn btn-sm mt-2 disabled" : "btn btn-sm mt-2"}
                                style={stylesWMS.Alert}
                                onClick={() => this.setState({showBar: !this.state.showBar})}>Scan Transfer
                        </button>
                    </div>
                    :
                    null
                }
                {
                    (this.state.showBar) ?
                        <div className="col-md-8 form-group m-4" style={stylesWMS.InputBar}>
                            <h5>Scan Item</h5>
                            <input autoFocus ref={this.ref} className="form-control" style={{width: "50%"}}
                                   onKeyDown={(e) => {
                                       if (e.keyCode === 13) {
                                           this.searchItem();
                                       }
                                   }} onChange={(e) => this.onChangeBar(e)} value={this.state.bar}/>
                        </div>
                        : null
                }
                <div className="p-4">
                    <input type="text" className="form-control" placeholder="Search Here"
                           onInput={text => this.onSearch(text)}/>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                    {(this.state.showalert) ?
                        <div
                            className={(this.state.alertdanger === "Work Successful") ? "alert alert-success" : "alert alert-danger"}>{this.state.alertdanger}</div>
                        : null}
                    {this.Header()}
                    {this.subHeader()}
                    <div className=" p-4" style={stylesMed.cardBackgroundColor}>
                        <div className="row">
                            {this.state.tableHeader.map((item, index) => {
                                return (
                                    <div
                                        className={(this.state.transaction === 0) ? "little col-3 text-center" : "little col-3 text-center"}
                                        key={index}><b> {item.name}</b></div>
                                )
                            })
                            }
                        </div>
                        <hr/>
                        {(this.state.loadingData)
                            ? <div className="pt-3 text-center">
                                <div className="spinner-border" style={stylesMed.spinner}></div>
                            </div>
                            :
                            this.state.orders.map((item, index) => {
                                if (this.state.transaction === 0) {
                                    return (
                                        <div>
                                            <div className="row" key={index} onClick={() => this.onOrderClick(item)}>
                                                <div className="littlet col-3 text-center">{(item.origin === undefined) ? item.name : item.origin}</div>
                                                <div
                                                    className="littlet col-3 text-center">{(item.date_order === undefined) ? item.scheduled_date.substring(0, 10) : item.date_order.substring(0, 10)}</div>
                                                <div
                                                    className="littlet col-3 text-center">{(item.location_id !== undefined) ? item.location_id[1] : item.source_location_id[1]}</div>
                                                <div
                                                    className="littlet col-3 text-center">{(item.location_dest_id !== undefined) ? item.location_dest_id[1] : item.dest_location_id[1]}</div>
                                            </div>
                                            <hr/>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div>
                                            <div className="row" key={index} onClick={() => this.onOrderClick(item)}>
                                                <h4 className="col text-center">{(item.origin === undefined) ? item.name : item.origin}</h4>
                                                <h4 className="col text-center">{(item.date_order === undefined) ? item.scheduled_date.substring(0, 10) : item.date_order.substring(0, 10)}</h4>
                                            </div>
                                            <hr/>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            );
        } else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    {this.Header()}
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }

    }
}
